import styled, { css } from "styled-components";
import { PillButton } from "../../../../../../../CommonComponents/commonStyles";

let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const styles = css`
  font-family: HelveticaNeue-Medium;
  font-size: 16px;
  color: #006778;
`;

const fontCommonStyle = css`
  font-family: HelveticaNeue;
  font-size: 16px;
  color: #505050;
`;

const cursorPointer = css`
  cursor: pointer;
`;

export const WrapLabel = styled.div`
&&& {
  .ant-form-item-label{
    margin-bottom: 10px;
   }
   @media only screen and (min-width: 320px) and (max-width: 767px) {  
    &&& {
      .ant-form-item-label{
        padding: 0;
       }
   }
}
`
export const LabelWrapper = styled.span`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
line-height: ${props => props.theme.lineHeight.secondary};
letter-spacing: ${props => props.theme.letterSpacing.zero};
color: ${props => props.theme.fontColors.textColor};
font-weight: normal;
.ant-col ant-form-item-label{
  height:20px;
 }
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
}
`;

export const InputWrapper = styled.div`
input,
.ant-select-selection--single {
height: 40px;
}
.ant-input{
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  letter-spacing:  ${props => props.theme.letterSpacing.zero};
  line-height: ${props => props.theme.lineHeight.tertiaryUpdated};
  color: ${props => props.theme.fontColors.textColor};
  border: solid 1px #d4d4d4;
  border-radius: 0;
  padding-left: 20px;

  &::placeholder {
    color: ${props => props.theme.fontColors.placeholder};
    /* padding-left: 9px; */
  }
  &:hover, &:focus{
  border: 1px solid #505050 !important;
  box-shadow: none !important;
  }

  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary} !important;
  }
}

.ant-input[disabled]{
  color: ${props => isSafari ? props.theme.colors.black : props.theme.fontColors.textColor};
}
.ant-form-item {
  margin-bottom: 34px;
}
&& .cropped-text {
  text-overflow: ellipsis !important;
}
`;

export const SelectErrorWrapper = styled.div`
input,
.ant-select-selection--single {
height: 40px;
}
.ant-input{
  border: solid 1px #d4d4d4;
  border-radius: 0;
}
.ant-input[disabled]{
  color: #505050;
}
width: 300px;
margin-bottom:5px;
`;

export const InputMargin = styled.div`
.ant-form-item{
  margin-bottom: 40px;
}
`

export const PillButtonAdd = styled(PillButton)`
  ${styles}
  font-size: 14px;
  background-color: #f5f5f5;
  margin-bottom: 16px;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 16px;
  }
`;

export const InputWrap = styled.div`

input,
.ant-select-selection--single {
height: 40px !important;
}

.ant-select-arrow-icon {
display: none;
}

input::placeholder {
color: #d4d4d4;
}

.ant-select-selection {
border-radius: 0;
display: flex;
align-items: center;
border: 1px solid #d4d4d4;
}

.ant-input {
border-radius: 0;
color: #505050;
font-size: 16px;
padding: 0 20px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
font-size: 14px;
}
}

.ant-input[disabled]{
  color: #505050;
}

.ant-calendar-picker-input {
margin-top: 0 !important;
}
`;

const titleCommmon = css`
${fontCommonStyle}
line-height: 1.25;
letter-spacing: 0.6px;
font-weight: normal;
`;

export const TitleWrapper = styled.div`
${titleCommmon}
margin-bottom: 10px;
.ant-form-item-label {
  label::after {
  margin: 0 !important;
  }
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
font-size: 14px;
}
`;

const InputWrapped = styled.div`
  input,
  .ant-select-selection--single {
    height: 40px !important;
  }

  .ant-select-arrow-icon {
    display: none;
  }

  input::placeholder {
    color: #d4d4d4;
  }

  .ant-select-selection {
    border-radius: 0;
    display: flex;
    align-items: center;
    border: 1px solid #d4d4d4;
  }

  .ant-input {
    border-radius: 0;
    color: #505050;
    font-size: 16px;
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
    }
  }

  .ant-calendar-picker-input {
    margin-top: 0 !important;
  }
`;


export const InputWrapperGraded = styled(InputWrapped)`
  input,
  .ant-select-selection--single {
    background-color: #f2f2f2 !important;
  }

  input {
    padding: 0 20px;
  }

  input::placeholder {
    color: #d4d4d4;
  }

  .ant-select-selection-selected-value {
    color: #505050;
    font-size: 16px;
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
    }
    
  }

  .ant-select-selection__rendered {
    margin: 0;
  }
`;

export const PlaceholderWrap = styled.div`
font-family: HelveticaNeue;
font-size: 16px;
color: red;
`
export const InfoMessage = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary}
  color: ${props => props.theme.fontColors.gray}
  font-style: italic;
  line-height: ${props => props.theme.lineHeight.secondary};
`